import { useMemo } from 'react';

export const containChanges = (a: any, b: any) => {
  const aa = JSON.stringify(transform(a));
  const bb = JSON.stringify(transform(b));
  return aa.localeCompare(bb) !== 0;
};

const transform = (a: any) => (a === undefined ? 'null' : a);

const trimFinalParagraphTag = (data: any) => {
  if (data?.body_as_html) {
    return {
      ...data,
      body_as_html: data.body_as_html.replace(/<p><\/p>$/, ''),
    };
  }
  return data;
};

const useContainChanges = (a: any, b: any) => {
  const aa = JSON.stringify(transform(a));

  const trimmedB = trimFinalParagraphTag(b);
  const bb = JSON.stringify(transform(trimmedB));

  const containChanges = useMemo(() => {
    const nn = aa.localeCompare(bb) !== 0;
    return nn;
  }, [aa, bb]);
  return containChanges;
};

export default useContainChanges;
